export const FONT_FAMILIES = [
  { value: 'Bangers', label: 'Bangers (Comic)' },
  { value: 'Quicksand', label: 'Quicksand' },
  { value: 'Andika', label: 'Andika' },
  { value: 'Baskervville', label: 'Baskervville' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Great Vibes', label: 'Great Vibes' },
];

export const FONT_SIZES = [
  { value: '12px', label: '12' },
  { value: '14px', label: '14' },
  { value: '16px', label: '16' },
  { value: '18px', label: '18' },
  { value: '24px', label: '24' },
  { value: '32px', label: '32' },
];

export const LINE_SPACING = [
  { value: '1', label: 'Single' },
  { value: '1.15', label: '1.15' },
  { value: '1.3', label: '1.30' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: 'Double' },
];

export const DEFAULT_TEXT_STYLE = {
  fontFamily: 'Arial',
  fontSize: '16px',
  lineHeight: '1',
  color: '#000000',
  textAlign: 'left',
  verticalAlign: 'top',
  fontWeight: 'normal',
  fontStyle: 'normal',
  textDecoration: 'none',
};
